import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonJsonEn from 'locales/en/common.json';
import commonJsonPl from 'locales/pl/common.json';
import specificationJsonEn from 'locales/en/specification.json';
import specificationJsonPl from 'locales/pl/specification.json';
import timingJsonEn from 'locales/en/timing.json';
import timingJsonPl from 'locales/pl/timing.json';
import emptyStatesJsonEn from 'locales/en/empty_states.json';
import emptyStatesJsonPl from 'locales/pl/empty_states.json';
import authenticationJsonEn from 'locales/en/authentication.json';
import authenticationJsonPl from 'locales/pl/authentication.json';
import componentsJsonEn from 'locales/en/components.json';
import componentsJsonPl from 'locales/pl/components.json';
import ordersJsonEn from 'locales/en/orders.json';
import ordersJsonPl from 'locales/pl/orders.json';
import warehouseReleaseJsonEn from 'locales/en/warehouse_releases.json';
import warehouseReleaseJsonPl from 'locales/pl/warehouse_releases.json';
import exceptionsJsonEn from 'locales/en/exceptions.json';
import exceptionsJsonPl from 'locales/pl/exceptions.json';
import orderOperatorsEn from 'locales/en/order_operators.json';
import orderOperatorsPl from 'locales/pl/order_operators.json';

const resources = {
  en: {
    common: commonJsonEn,
    specification: specificationJsonEn,
    timing: timingJsonEn,
    emptyStates: emptyStatesJsonEn,
    authentication: authenticationJsonEn,
    components: componentsJsonEn,
    orders: ordersJsonEn,
    warehouseReleases: warehouseReleaseJsonEn,
    exceptions: exceptionsJsonEn,
    orderOperators: orderOperatorsEn,
  },
  pl: {
    common: commonJsonPl,
    specification: specificationJsonPl,
    timing: timingJsonPl,
    emptyStates: emptyStatesJsonPl,
    authentication: authenticationJsonPl,
    components: componentsJsonPl,
    orders: ordersJsonPl,
    warehouseReleases: warehouseReleaseJsonPl,
    exceptions: exceptionsJsonPl,
    orderOperators: orderOperatorsPl,
  },
};

i18n.use(initReactI18next).init({
  resources,
  defaultNS: 'common',
  keySeparator: false,
  lng: localStorage.getItem('language') || 'pl',
  interpolation: {
    escapeValue: false,
    format(value, format) {
      switch (format) {
        case 'capitalize': {
          return value.charAt(0).toUpperCase() + value.slice(1);
        }
        case 'uppercase': {
          return value.toUpperCase();
        }
        default:
          return value;
      }
    },
  },
});

export default i18n;
